import ClanCard from "./ClanCard";

const ClansSection = () => {
  return (
    <section className="container mx-auto py-16">
      <h2 className="font-serif font-bold text-3xl md:text-4xl text-center mb-12">Our Clans</h2>
      <div className="grid md:grid-cols-3 gap-8">
        <ClanCard
          title="[-TFD-]"
          description="Our main clan for experienced players looking to push their limits. Under the leadership of our Supreme Commander ARC117."
          leftIcon="Trophy"
          leftText="Great Legacy"
          rightIcon="Users"
          rightText="Experienced Players"
        />
        <ClanCard
          title="[-TFD2]"
          description="Home to active players focusing on improvement and competitive play. With our unique Alpha/Bravo system for Clan Battles."
          leftIcon="Ship"
          leftText="Active CB Teams"
          rightIcon="Trophy"
          rightText="Rising Stars"
        />
        <ClanCard
          title="[-TFD3]"
          description="Our community's cozy retirement home. A relaxed environment for veteran community members who want to take it easy."
          leftIcon="Coffee"
          leftText="Social Focus"
          rightIcon="MessageSquare"
          rightText="Active Community"
        />
      </div>
    </section>
  );
};

export default ClansSection;